import Vue from 'vue';
import BackToTop from './BackToTop';
// Modals
import ModalBrochures from './brochures/ModalBrochures';
import ContactForm from './ContactForm';
import AdvicePanel from './AdvicePanel';
// single-cruise
import CruiseConfigurator from './cruise-configurator/CruiseConfigurator';
import addToWishlistCta from './cruise-product/AddToWishlistCta';
import ShareCruise from './cruise-product/ShareCruise';
// Taxonomy-Destination
import CruiseCard from './cruise-product/CruiseCard';
import ExtensionsSlider from './cruise-product/ExtensionsSlider';
import KeyMomentSlider from './cruise-product/KeyMomentSlider';
// Components
import CustomSelect from './CustomSelect';
import FloatingLabel from './FloatingLabel';
import LocalisedPhone from './LocalisedPhone';
// HomePage
import HomeSlider from './home-page/HomeSlider';
import Testimonials from './home-page/Testimonials';
import LocalTime from './LocalTime';
import LoginPanel from './LoginPanel';
// Magazine
import ArticleList from './magazine/ArticleList';
import PhotoTestimonialCarousel from './magazine/PhotoTestimonialCarousel';
import SingleTravelogueContent from './magazine/SingleTravelogueContent';
import TravelogueList from './magazine/TravelogueList';
// Menu
import RichMenuDestinations from './menus/RichMenuDestinations';
import RichMenuNavires from './menus/RichMenuNavires';
import NewsletterPanel from './NewsletterPanel';
import ScrollTo from './ScrollTo';
// Ship
import ShipCarousel from './ship/ShipCarousel';
import SocialWall from './social-wall/SocialWall';
import SocialWallAddPhoto from './social-wall/SocialWallAddPhoto';
import SocialWallDetail from './social-wall/SocialWallDetail';
import SocialWallDashboardList from './social-wall/SocialWallDashboardList';
import ShareSocialPhoto from './social-wall/ShareSocialPhoto';
import Tabs from './Tabs';
import CruiseCount from './taxonomy-destination/CruiseCount';
import DestinationWorldMap from './taxonomy-destination/DestinationWorldMap';
import DestinationWorldMapHome from './taxonomy-destination/DestinationWorldMapHome';
import SearchCruiseForm from './taxonomy-destination/SearchCruiseForm';
import ThematiqueCard from './taxonomy-thematique/ThematiqueCard';
// Taxonomy-Thematique
import ThematiqueList from './taxonomy-thematique/ThematiqueList';
import TabletPortraitAlert from './TabletPortraitAlert'

// Mobile Custom Select
import ShipFilter from './ship/ShipFilter';
import GuideFilter from './guide/GuideFilter';
import HomeNews from './home-news';

Vue.component('floating-label', FloatingLabel);
Vue.component('cruise-configurator', CruiseConfigurator);
Vue.component('custom-select', CustomSelect);
Vue.component('local-time', LocalTime);
Vue.component('key-moment-slider', KeyMomentSlider);
Vue.component('extensions-slider', ExtensionsSlider);
Vue.component('tabs', Tabs);
Vue.component('cruise-card', CruiseCard);
Vue.component('rich-menu-destinations', RichMenuDestinations);
Vue.component('rich-menu-navires', RichMenuNavires);
Vue.component('scroll-to', ScrollTo);
Vue.component('cruise-count', CruiseCount);
Vue.component('search-cruise-form', SearchCruiseForm);
Vue.component('ship-carousel', ShipCarousel);
Vue.component('thematique-list', ThematiqueList);
Vue.component('back-to-top', BackToTop);
Vue.component('thematique-card', ThematiqueCard);
Vue.component('article-list', ArticleList);
Vue.component('travelogue-list', TravelogueList);
Vue.component('photo-testimonial-carousel', PhotoTestimonialCarousel);
Vue.component('social-wall', SocialWall);
Vue.component('social-wall-detail', SocialWallDetail);
Vue.component('social-wall-add-photo', SocialWallAddPhoto);
Vue.component('single-travelogue-content', SingleTravelogueContent);
Vue.component('home-slider', HomeSlider);
Vue.component('destination-world-map', DestinationWorldMap);
Vue.component('destination-world-map-home', DestinationWorldMapHome);
Vue.component('testimonials', Testimonials);
Vue.component('modal-brochures', ModalBrochures);
Vue.component('contact-form', ContactForm);
Vue.component('login-panel', LoginPanel);
Vue.component('newsletter-panel', NewsletterPanel);
Vue.component('ship-filter', ShipFilter);
Vue.component('guide-filter', GuideFilter);
Vue.component('add-to-wishlist-cta', addToWishlistCta);
Vue.component('share-cruise', ShareCruise);
Vue.component('social-wall-dashboard-list', SocialWallDashboardList);
Vue.component('share-social-photo', ShareSocialPhoto);
Vue.component('localised-phone', LocalisedPhone);
Vue.component('tablet-portrait-alert', TabletPortraitAlert);
Vue.component('advice-panel', AdvicePanel);



// WEBPACK FOOTER //
// ./assets/js/components/index.js